import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { makeTextFieldClear, makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import { Table } from 'shared/ui/TableNew'
import { ContactStatisticBulkActions } from 'widgets/ContactStatistic'
import { useReviewAnalyticsContext } from 'pages/reviews/context'
import { columns } from 'pages/reviews/pages/viewReview/ui/ReviewContactsTable/columns'
import { clickedColumns } from 'pages/reviews/pages/viewReview/ui/ReviewContactsTable/clickedColumns'
import styles from './styles.module.scss'

export const ReviewContactsTable = observer(() => {
  const {
    items,
    tableStore,
    search,
    setSearch,
    activeFilter,
    isReviewAccountType,
    contactsTagsModalStore,
    selectedContactIds,
    onSuccessDelete,
    onSuccessManageTags,
  } = useReviewAnalyticsContext()
  const isClickedColumns = isReviewAccountType(activeFilter) || activeFilter === 'clicked'

  return (
    <Box display={'flex'} flexDirection={'column'} flex={1} marginInline={'16px'}>
      <div className={styles.search}>
        <TextField
          onChange={setSearch}
          variant={'integrated'}
          value={search}
          InputProps={{ placeholder: 'Search...' }}
          leftActions={[
            makeTextFieldIcon({
              icon: 'search',
              fontSize: 18,
              color: 'var(--content-primary-tertiary)',
              margin: '0 9px 0 4px',
            }),
          ]}
          rightActions={[
            makeTextFieldClear({
              isButton: true,
              isVisibleWithoutFocus: true,
              intent: 'passive',
            }),
          ]}
        />
      </div>
      <Box display={'flex'} flexDirection={'column'} flex={1} className={styles.tableWrap}>
        <Table
          ariaLabel={'ReviewContacts'}
          virtualization
          pinnedColumnIds={['full_name']}
          store={tableStore}
          columns={isClickedColumns ? clickedColumns : columns}
          rows={items}
          withCheckbox
          headerLeftContentProps={{
            actionsContent: (
              <ContactStatisticBulkActions
                contactsTagsModalStore={contactsTagsModalStore}
                selectedContactIds={selectedContactIds}
                search={search}
                onSuccessDelete={onSuccessDelete}
                onSuccessManageTags={onSuccessManageTags}
                withNewActions
              />
            ),
          }}
        />
      </Box>
    </Box>
  )
})
